import React from 'react';
import { BsFacebook } from 'react-icons/bs';
import { RiInstagramFill } from 'react-icons/ri';
import { SiGithub } from 'react-icons/si';

const headerSocial = () => {
  return (
    <div className="header-social">
      <a href="https://github.com/Yacine166" target="_blank">
        <SiGithub />
      </a>
      <a href="https://www.facebook.com/ayacine16" target="_blank">
        <BsFacebook />
      </a>
      <a href="https://instagram.com/yacine.prog" target="_blank">
        <RiInstagramFill />
      </a>
    </div>
  );
};

export default headerSocial;
